/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.partners.detail.controllers', [
  'ui.router',
  'angularUUID2',
  'acme.common.service.api',
  'acme.common.service.venue',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.userPreferences',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition'
])

.controller('PartnersDetailController', ['$scope', '$state', '$filter', '$timeout', 'uuid2', 'ApiService', 'HelpersService', 'CalendarService', 'VenueService', 'UserPreferencesService', 'NoticeFactory', 'PartnerData', 'CategoriesData', 'GridStateFactory', 'GridDefinitionFactory', function($scope, $state, $filter, $timeout, uuid2, ApiService, HelpersService, CalendarService, VenueService, UserPreferencesService, NoticeFactory, PartnerData, CategoriesData, GridStateFactory, GridDefinitionFactory) {

    $scope.partnersDetail = {

      componentType: 'organization',

      model: {},
      accountCategories: [],
      otherAddresses: [],
      orders: [],
      attributes: [],

      isUpdatingCategory: false,
      isUpdatingPayment: false,

      isLoaded: false,

      notes: '',
      ordersSearch: '',
      accountCategory: '',
      selectedAccountCategory: '',
      getStatusLabel: VenueService.getStatusLabel,
      dateFormat: UserPreferencesService.getDateFormat('standardDate'),
      tab: 'orders',

      payment: {
        id: false,
        type: 'fullPayment',
        accountId: false,
        ticketDelivery: 'print',
        balanceDueDays: 0,
        depositDueDays: 0,
        depositMinimumAmount: 0,
        depositMinimumPercent: 0,
        uniqueVoucherNumbers: false
      },

      details: {
        columns: 2,
        data: 'partnersDetail.model.company',
        include: [
          'name',
          'companyUrl',
          'phoneNumber',
          'streetAddress1',
          'streetAddress2',
          'city',
          'state',
          'zipCode',
          'country'
        ]
      },

      primaryContactDetails: {
        columns: 2,
        data: 'partnersDetail.model.primaryContact',
        include: [
          'firstName',
          'lastName',
          'email',
          'phoneNumber',
          'streetAddress1',
          'streetAddress2',
          'city',
          'state',
          'zipCode',
          'country'
        ]
      },

      secondaryContacts: [],

      secondaryContactsOptionsOverride: {
        paginationPageSize: 25,
        data: 'partnersDetail.secondaryContacts',
        appScopeProvider:{
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.partnersDetail.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns) {
            $scope.partnersDetail.onDataGridSortChange(grid, columns);
          }        },
        columnDefs: [
          {
            field: 'id',
            displayName: 'ID',
            visible: false
          },
          {
            field: 'externalId',
            displayName: 'External ID',
            visible: false
          },
          {
            field: 'primary',
            displayName: 'Primary',
            visible: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><span data-ng-show="row.entity.primary">Yes</span><span data-ng-hide="row.entity.primary">No</span></div>'
          },
          {
            field: 'firstName',
            displayName: 'First Name'
          },
          {
            field: 'lastName',
            displayName: 'Last Name'
          },
          {
            field: 'email',
            displayName: 'Email'
          },
          {
            field: 'phoneNumber',
            displayName: 'Phone Number'
          },
          {
            field: 'addressId',
            displayName: 'Address ID',
            visible: false,
          },
          {
            field: 'streetAddress1',
            displayName: 'Address 1'
          },
          {
            field: 'city',
            displayName: 'City'
          },
          {
            field: 'state',
            displayName: 'State'
          },
          {
            field: 'country',
            displayName: 'Country'
          },
          {
            field: 'zipCode',
            displayName: 'Zip Code'
          }
        ]
      },

      viewId: '',
      ordersGridState: new GridStateFactory(),
      contactsGridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      gridDefinitionContacts: new GridDefinitionFactory(),
      partnersDetailOrdersListGridName: $state.current.name+'.grid0',
      partnersDetailContactsListGridName: $state.current.name+'.grid1',

      ordersOptionsOverride: {
        paginationPageSize: 25,
        enableGridMenu: false,
        data: 'partnersDetail.orders.list',
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.partnersDetail.onOrdersDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDblClick: function (item) {
            $scope.partnersDetail.onOrdersDblClick(item);
          },
          onDataGridSortChange: function(grid, columns) {
            $scope.partnersDetail.onOrdersDataGridSortChange(grid, columns);
          }
        },
        columnDefs: [
          {
            field: 'view',
            displayName: 'View',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.partnersDetail.ordersOptionsOverride.appScopeProvider.onDblClick(row);
            },
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">View<span class="sr-only"> Details for Order No. {{ row.entity.orderNumber }}</span></a></div>',
            visible: true,
            enableHiding: false,
            enableSorting: false,
            suppressSizeToFit: true
          },
          {
            field: 'accountId',
            visible: false
          },
          {
            field: 'orderId',
            visible: false
          },
          {
            field: 'orderNumber',
            displayName: 'Order No.'
          },
          {
            field: 'totalAmount',
            displayName: 'Original Price',
            cellFilter: 'currency'
          },
          {
            field: 'discountedTotalAmount',
            displayName: 'Discounted Price',
            cellFilter: 'currency'
          },
          {
            field: 'orderBalance',
            displayName: 'Balance Due',
            cellFilter: 'currency'
          },
          {
            field: 'orderDate',
            displayName: 'Order Date',
            sort: {
              direction: 'desc'
            },
            cellFilter: 'date : "'+HelpersService.dateFormats.shortDate+'"'
          }
        ]
      },

      membershipsGridState: new GridStateFactory(),

      membershipsGrid: {
        pageSize: 10,
        paginate: true,
        useExternalPagination: false,
        useExternalSorting: true,
        enableRowSelection: false,
        multiselect: false,
        showFooter: true,
        columns: [
          {
            field: 'view',
            displayName: 'View',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.partnersDetail.onMembershipsGridDoubleClick(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents" data-ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onGridDblClick(row)" role="link">View<span class="sr-only"> Details</span></a></div>',
            visible: true,
            enableHiding: false,
            enableSorting: false
          },
          {
            field: 'id',
            displayName: 'ID',
            visible: false
          },
          {
            field: 'acmeMembershipNumber',
            displayName: 'Acme Membership Number',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'category',
            displayName: 'Category',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'program',
            displayName: 'Program',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'subcategory',
            displayName: 'Subcategory',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'email',
            displayName: 'Email',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'externalMembershipId',
            displayName: 'External Membership Id',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'importId',
            displayName: 'Import Id',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'offeringId',
            displayName: 'Offering Id',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'organizationId',
            displayName: 'Org. Id',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'organizationName',
            displayName: 'Org. Name',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'membershipCategory',
            displayName: 'Membership Category',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'membershipStanding',
            displayName: 'Membership Standing',
            headerTooltip: true,
            visible: true
          },
          {
            field: 'isGift',
            displayName: 'Gift'
          }
        ]

      },

      attributesGridState: new GridStateFactory(),

      attributeGridOptions: {
        showFooter: true,
        multiSelect: false,
        paginate: true,
        pageSize: 50,
        columnDefs: [
          {
            field: 'category',
            displayName: 'Category',
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'description',
            displayName: 'Description'

          },
          {
            field: 'notes',
            displayName: 'Notes'
          },
          {
            field: 'date',
            displayName: 'Date',
            cellFilter: 'date: "' + HelpersService.dateFormats.sortDate + '"',
            cellFormatter: function(item) {
              return $filter('date')(item.value, HelpersService.dateFormats.shortDateTime);
            }
          }
        ]
      },

      notice: new NoticeFactory(),

      init: function() {
        this.viewId = $state.current.name;
        $scope.$emit('Application::contentTitleChange', {
          title: 'Organization Details',
          buttonRight: {
            label: 'Edit Organization',
            permissions: 'ACCT_UPDATE',
            action: function() {
              $state.go('application.partners.edit', { accountId: $scope.partnersDetail.model.company.id });
            }
          }
        });

        if (PartnerData.data && PartnerData.data.success) {
          this.success.init(PartnerData);
        }else{
          this.error.init(PartnerData);
        }

        if (CategoriesData.data && CategoriesData.data.success) {
          this.success.initCategories(CategoriesData);
        }else{
          this.error.initCategories(CategoriesData);
        }

        this.getPartnerPayments($state.params.id);
        this.membershipsGridState.updateGridState(null, this.membershipsGrid.pageSize, 'name');

        this.gridDefinition.init(this.partnersDetailOrdersListGridName, this.ordersOptionsOverride, this.viewId, $state.current.data.enablePreferences);
        this.gridDefinitionContacts.init(this.partnersDetailContactsListGridName, this.secondaryContactsOptionsOverride, this.viewId, $state.current.data.enablePreferences)
        $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);
        this.getPartnerMemberships($state.params.id);
        this.getPartnerMembershipAttributes($state.params.id);
      },

      initData: function () {
        var self = $scope.partnersDetail;
        var props = self.gridDefinition.getGridState()
        var contactProps = self.gridDefinitionContacts.getGridState();

        self.initDateFormats();

        self.ordersGridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.contactsGridState.updateGridState(contactProps.page, contactProps.pageSize, contactProps.sortField, contactProps.sortDirection);
        if (self.gridDefinition.isAccessbilityEnabled) {
          self.getPartnerOrders($state.params.id);
        }
        if (self.gridDefinitionContacts.isAccessbilityEnabled) {
          self.getPartnerContacts($state.params.id);
        }
      },

      initDateFormats: function() {
        var self = $scope.partnersDetail;
        
        self.membershipsGrid.columns.push({
          field: 'membershipExpirationDate',
          displayName: 'Expires',
          headerTooltip: true,
          visible: true,
          cellFilter: 'date: "' + UserPreferencesService.getDateFormat('shortDate', 'dateFormat') + '"',
          cellFormatter: function(item) {
            return $filter('date')(item.value, UserPreferencesService.getDateFormat('shortDate', 'dateFormat'));
          }
        });

        self.membershipsGrid.columns.push({
          field: 'membershipJoinedDate',
          displayName: 'Joined',
          headerTooltip: true,
          visible: true,
          cellFilter: 'date: "' + UserPreferencesService.getDateFormat('shortDate', 'dateFormat') + '"',
          cellFormatter: function(item) {
            return $filter('date')(item.value, UserPreferencesService.getDateFormat('shortDate', 'dateFormat'));
          }
        });

        self.membershipsGrid.columns.push({
          field: 'membershipStartDate',
          displayName: 'Membership Start Date',
          headerTooltip: true,
          visible: true,
          cellFilter: 'date: "' + UserPreferencesService.getDateFormat('shortDate', 'dateFormat') + '"',
          cellFormatter: function(item) {
            return $filter('date')(item.value, UserPreferencesService.getDateFormat('shortDate', 'dateFormat'));
          }
        });
      },

      initPartnerPayments: function() {
        this.isUpdatingPayment = true;
        ApiService.partners.payments.create(this.payment).then(this.success.initPartnerPayments, this.error.initPartnerPayments);
      },

      getPartnerOrders: function(id) {
        ApiService.orders.partners.list(angular.extend({ id: id }, this.ordersGridState.getGridState())).then(this.success.getPartnerOrders, this.error.getPartnerOrders);
      },

      getPartnerPayments: function(id) {
        ApiService.partners.payments.account(id).then(this.success.getPartnerPayments, this.error.getPartnerPayments);
      },

      getPartnerContacts: function(id) {
        $scope.partnersDetail.gridDefinitionContacts.isLoaded = false;
        ApiService.organizations.contacts.list(angular.extend({ organizationId: id }, this.contactsGridState.getGridState())).then(this.success.getPartnerContacts, this.error.getPartnerContacts);
      },

      getPartnerMemberships: function(id) {
        ApiService.organizations.membership.list({ id: id }).then(this.success.getPartnerMemberships, this.error.getPartnerMemberships);
      },

      getPartnerMembershipAttributes: function(id) {
        ApiService.organizations.membership.attributes(angular.extend({ id: id }, this.attributesGridState.getGridState())).then(this.success.getPartnerMembershipAttributes, this.error.getPartnerMembershipAttributes);
      },

      convertToMembership: function() {
        var uuid = uuid2.newuuid();

        ApiService.membership.create({
          membershipMethod: 'standard',
          importId: uuid,
          membershipTypeId: 36,
          externalMembershipId: uuid2.newuuid(),
          membershipJoinedDate: CalendarService.toISO8601(new Date()),
          membershipStartDate: CalendarService.toISO8601(new Date()),
          membershipExpirationDate: CalendarService.toISO8601(new Date()).replace('-2016', '-2017'),
          membershipStanding: "new",
          membershipCategory: "Darling",
          categoryId: "57c781216b7ea011172683b7",
          cardHolders: [],
          entitlements: [],
          offeringId: "a3b1c0528f2142a2a5a7a914db14216e",
          pricePointId: "579a91a56b7ea021566c4fc6",
          organizationId: $state.params.id,
          orgImportId: uuid
        }).then(function(response) {}, function(response) {});
      },

      changeCategory: function() {
        this.isUpdatingCategory = true;
      },

      updateCategory: function() {
        this.isUpdatingCategory = false;
        console.log('PartnersDetailController::updateCategory', this.selectedAccountCategory,  this.model.accountCategoryRelation);
        if (this.model.accountCategoryRelation) {
          ApiService.partners.categories.reassign({
            id: this.model.accountCategoryRelation.id,
            accountId: this.model.accountCategoryRelation.accountId,
            categoryId: this.selectedAccountCategory.id
          }).then(this.success.updateCategory, this.error.updateCategory);
        }else{
          ApiService.partners.categories.assign({
            accountId: this.model.company.id,
            categoryId: this.selectedAccountCategory.id
          }).then(this.success.updateCategory, this.error.updateCategory);
        }
      },

      cancelChangeCategory: function() {
        this.isUpdatingCategory = false;
      },

      isTab: function(tab) {
        return (this.tab === tab);
      },

      setTab: function(tab) {
        this.tab = tab;
        if (this.tab === 'orders') {
          this.getPartnerOrders($state.params.id);
        }else if (this.tab === 'secondaryContacts') {
          this.getPartnerContacts($state.params.id);
        }else if (this.tab === 'memberships') {
          this.getPartnerMemberships($state.params.id);
        }else if (this.tab === 'attributes') {
          this.getPartnerMembershipAttributes($state.params.id);
        }
      },

      hasMemberships: function() {
        return (this.memberships instanceof Array && this.memberships.length > 0);
      },

      hasAttributes: function() {
        return (this.attributes instanceof Array && this.attributes.length > 0);
      },

      hasOrders: function() {
        return (this.orders.list instanceof Array && this.orders.list.length > 0);
      },

      filterContacts: function(contacts, primary) {
        var filtered = [], i, ii;
        for(i = 0, ii = contacts.length; i < ii; i++) {
          if(contacts[i].primary === primary) {
            filtered.push(contacts[i]);
          }
        }
        return filtered;
      },

      updatePayment: function(payment) {
        this.notice.hideErrorMessages();
        this.notice.hideSuccessMessages();
        this.isUpdatingPayment = true;
        ApiService.partners.payments.update(payment).then(this.success.updatePayment, this.error.updatePayment);
      },

      createPayment: function(payment) {
        this.notice.hideErrorMessages();
        this.notice.hideSuccessMessages();
        this.isUpdatingPayment = true;
        ApiService.partners.payments.create(payment).then(this.success.createPayment, this.error.createPayment);
      },

      approve: function(requestId, index) {
        ApiService.partners.approve(requestId).then(function(response) {
          $scope.partnersDetail.model.requests[index].status = response.data.payload.status;
          $scope.partnersDetail.success.approve.apply($scope, arguments);
        }, function() {
          $scope.partnersDetail.error.approve.apply($scope, arguments);
        });
      },

      decline: function(requestId, index) {
        ApiService.partners.decline(requestId).then(function(response) {
          $scope.partnersDetail.model.requests[index].status = response.data.payload.status;
          $scope.partnersDetail.success.decline.apply($scope, arguments);
        }, function() {
          $scope.partnersDetail.error.decline.apply($scope, arguments);
        });
      },

      updateNotes: function() {
        var self = $scope.partnersDetail;
        self.notice.hideErrorMessages();
        self.notice.hideSuccessMessages();
        ApiService.partners.notes.update({
          id: self.model.requests[0].requestId,
          notes: self.notes
        }).then(self.success.updateNotes, self.error.updateNotes);
      },

      update: function() {},

      findAccountCategory: function(name) {
        var i, ii,
            r = false;

        for (i=0,ii=$scope.partnersDetail.accountCategories.length;i<ii;i++) {
          if (name === $scope.partnersDetail.accountCategories[i].name) {
            r = {
              index: i,
              category: $scope.partnersDetail.accountCategories[i]
            };
            break;
          }
        }
        console.log('PartnersDetailController::findAccountCategory', r, name, $scope.partnersDetail.accountCategories);

        return r;
      },

      processOrders: function(orders) {
        var i, ii;

        for (i=0,ii=orders.list.length;i<ii;i++) {
          orders.list[i].orderDate = $filter('date')(CalendarService.parseDate(orders.list[i].orderDate), UserPreferencesService.getDateFormat('shortDate', 'dateFormat'));
        }

        return orders;
      },

      success: {
        init: function(response) {
          var self = $scope.partnersDetail;
          self.model = response.data.payload;
          self.payment.accountId = self.model.company.id;
          self.notes = (self.model.requests[0]) ? self.model.requests[0].posNotes : '';
          if (self.model.company.name) {
            self.ordersSearch = '"' + self.model.company.name + '"';
          }
        },

        initCategories: function(response) {
          $scope.partnersDetail.accountCategories = response.data.payload.list;
          if ($scope.partnersDetail.model.accountCategoryRelation) {
            $scope.partnersDetail.selectedAccountCategory = $scope.partnersDetail.findAccountCategory($scope.partnersDetail.model.accountCategoryRelation.categoryName).category;
          }
        },

        initPartnerPayments: function(response) {
          var self = $scope.partnersDetail;

          self.success.createPayment(response);
        },

        getPartnerOrders: function(response) {
          var self = $scope.partnersDetail;
          self.orders = $scope.partnersDetail.processOrders(response.data.payload);
          self.gridDefinition.isLoaded = true;
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.orders.list.length, totalItems: self.orders.pagination.count});
          }, 10);
        },

        getPartnerPayments: function(response) {
          console.log('PartnersDetailController::success::getPartnerPayments', response);
          var self = $scope.partnersDetail,
              paymentType = response.data.payload;

          self.payment.id = paymentType.id;
          self.payment.type = paymentType.type;
          self.payment.accountId = paymentType.accountId || self.model.company.id;
          self.payment.uniqueVoucherNumbers = paymentType.uniqueVoucherNumbers;
          self.payment.ticketDelivery = paymentType.ticketDelivery;

          if (paymentType.balanceDue) {
            self.payment.balanceDueDays = paymentType.balanceDue.days || 0;
          }else{
            self.payment.balanceDueDays = 0;
          }

          if (paymentType.deposit) {
            self.payment.depositDueDays = paymentType.deposit.daysBeforeEvent || 0;
            self.payment.depositMinimumAmount = paymentType.deposit.minAmount || 0;
            self.payment.depositMinimumPercent = paymentType.deposit.percent || 0;
          }else{
            self.payment.depositDueDays = 0;
            self.payment.depositMinimumAmount = 0;
            self.payment.depositMinimumPercent = 0;
          }

        },

        getPartnerContacts: function(response) {
          var self = $scope.partnersDetail;
          var pagination = response.data.payload.pagination;

          self.secondaryContacts = response.data.payload.list;
          self.contactsGridState.setPropertyValue('totalItems', response.data.payload.pagination.count);

          self.isLoaded = true;
          self.gridDefinitionContacts.isLoaded = true;

          $timeout(function () {
            $scope.$broadcast('DataGrid::ResizeGrid', {
              name: self.gridDefinitionContacts.options.gridName,
              datasetLength: self.secondaryContacts.length,
              totalItems: pagination.count,
            });
          }, 10);
        },

        getPartnerMemberships: function(response) {
          var self = $scope.partnersDetail,
              paginated = false,
              list = [];

          if (response.data.payload instanceof Array) {
            list = response.data.payload;
          }else if (response.data.payload.list instanceof Array) {
            list = response.data.payload.list;
            paginated = true;
          }else if (!response.data.payload.hasOwnProperty('pagination')) {
            list = [response.data.payload];
          }

          self.memberships = list;
          self.membershipsGridState.setPropertyValue('totalItems', (paginated) ? response.data.payload.pagination.count : list.length);
          self.isLoaded = true;
        },

        getPartnerMembershipAttributes: function(response) {

          var self = $scope.partnersDetail;

          if (response.data.payload && response.data.payload.list instanceof Array) {
            self.attributes = response.data.payload.list;
          }else{
            self.attributes = [];
          }
          self.isLoaded = true;
        },

        approve: function(response) {},
        decline: function(response) {},
        updateNotes: function(response) {
          $scope.partnersDetail.notice.showSuccessMessages([{
            message: 'Sucessfully updated account notes'
          }]);
          $timeout(function() {
            $scope.partnersDetail.notice.hideSuccessMessages();
          }, 3000);
        },
        updateCategory: function(response) {
          $scope.partnersDetail.model.accountCategoryRelation = response.data.payload;
        },
        updatePayment: function(response) {
          $scope.partnersDetail.isUpdatingPayment = false;
          $scope.partnersDetail.notice.showSuccessMessages([{
            message: 'Sucessfully updated payment policy'
          }]);
          $timeout(function() {
            $scope.partnersDetail.notice.hideSuccessMessages();
          }, 3000);
        },
        createPayment: function(response) {
          $scope.partnersDetail.success.updatePayment(response);
        },
        update: function(response) {}

      },

      error: {
        init: function(response) {},
        initCategories: function(response) {},
        initPartnerPayments: function(response) {},
        getPartnerOrders: function(response) {},
        getPartnerPayments: function(response, config, headers, status) {
          var self = $scope.partnersDetail;

          if (response.status === 404) {
            self.initPartnerPayments($state.params.id);
          }
        },
        getPartnerMemberships: function(response) {},
        getPartnerMembershipAttributes: function(response) {},
        approve: function(response) {},
        decline: function(response) {},
        updateNotes: function(response) {
          $scope.partnersDetail.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        updateCategory: function(response) {},
        updatePayment: function(response) {
          $scope.partnersDetail.isUpdatingPayment = false;
          $scope.partnersDetail.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        createPayment: function(response) {
          $scope.partnersDetail.error.updatePayment(response);
        },
        update: function(response) {}
      },

      onOrdersDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
        var self = $scope.partnersDetail,
          data = {
            currentPage: newPageNumber || 1,
            pageSize: newPageSize || this.gridDefinition.options.paginationPageSize
          };

        self.ordersGridState.updateGridState(data.currentPage, data.pageSize);
        if (sortField) {
          self.ordersGridState.updateGridState(null, null, sortField, null);
        }
        if (sortDirection) {
          self.ordersGridState.updateGridState(null, null, null, sortDirection);
        }

        self.getPartnerOrders($state.params.id);
      },

      onOrdersDblClick: function(item) {
        $state.go('application.orders.detail.summary', { accountId: item.entity.tenantId, orderId: item.entity.orderId });
      },

      onOrdersDataGridSortChange: function(grid, columns) {
        var self = $scope.partnersDetail,
          data = columns[0];

        if(data) {
          self.ordersGridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getPartnerOrders($state.params.id);
        }
      },

      onMembershipsGridDoubleClick: function(item) {
        $state.go('application.partners.detail.membership', { membershipId: item.entity.id  });
      },

      onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
        var self = $scope.partnersDetail;
        self.contactsGridState.updateGridState(newPage, pageSize);
        self.getPartnerContacts($state.params.id);
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.partnersDetail, data = columns[0];
        if(data) {
          self.contactsGridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getPartnerContacts($state.params.id);
        }
      }

    };

    $scope.partnersDetail.init();

}]);
